<template>
  <div class="set-detail-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <el-tabs type="card" class="content-tab">
        <el-tab-pane label="操作权限">
          <Operating :data="data" />
        </el-tab-pane>
        <el-tab-pane label="数据权限">
          <Data :data="data" />
        </el-tab-pane>
        <el-tab-pane label="账户列表">
          <Account :data="data" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Operating from './components/operating.vue'
import Data from './components/data.vue'
import Account from './components/account.vue'
export default {
  data () {
    return {
      data: {}
    }
  },
  components: {
    Operating,
    Data,
    Account
  },
  mounted () {
    this.data = this.$route.query
  }
}
</script>

<style lang="less" scoped>
.set-detail-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
.el-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-tabs__content {
    flex: 1;
  }
  .el-tab-pane {
    height: 100%;
  }
}
.content-tab {
  .el-tabs__item {
    background-color: #e3e3e3;
    color: #7f7f7f;
  }
  .el-tabs__header .el-tabs__item.is-active {
    background-color: #409eff;
    color: #fff;
    border-bottom-color: #e4e7ed;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: 0;
  }
}
</style>
